"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ColumnExcelTable = require("./ColumnExcelTable");
var _moment = _interopRequireDefault(require("moment"));
var GiveawayExcelTable = /*#__PURE__*/function (_Vue) {
  function GiveawayExcelTable() {
    var _this;
    (0, _classCallCheck2.default)(this, GiveawayExcelTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, GiveawayExcelTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", void 0);
    (0, _defineProperty2.default)(_this, "cols", _ColumnExcelTable.colsExcelTable);
    return _this;
  }
  (0, _inherits2.default)(GiveawayExcelTable, _Vue);
  return (0, _createClass2.default)(GiveawayExcelTable, [{
    key: "generateValue",
    value: function generateValue(item, col, format) {
      // debugger;
      var split = col.split("."),
        a = item;
      split.forEach(function (element) {
        a = a[element] != undefined && a[element] != null ? a[element] : "";
      });
      if (format) {
        return this.$formatDate(a);
      }
      if (typeof a == "boolean") {
        return a ? "Yes" : "No";
      }
      if (col == "receiverPhone" || col == "customer.phone") {
        return "".concat(a);
      }
      return a;
    }
  }, {
    key: "dataTransform",
    get: function get() {
      var data = [];
      this.data.forEach(function (giveaway) {
        giveaway.giveawayDetails.forEach(function (e) {
          var tmp = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, giveaway), {}, {
            product: e.product,
            productQuantity: e.quantity,
            rowspan: 0,
            receiverFullAddress: "".concat(giveaway.receiverAddress, ", ").concat(giveaway.addressWard && giveaway.addressWard.nameWithType, ", ").concat(giveaway.addressDistrict && giveaway.addressDistrict.nameWithType, ", ").concat(giveaway.addressCity && giveaway.addressCity.nameWithType)
          });
          data.push(tmp);
        });
      });
      var count = 0;
      if (data.length > 0) {
        data.forEach(function (element, index) {
          count++;
          if (index < data.length - 1 && element.id != data[index + 1].id) {
            data[index + 1 - count].rowspan = count;
            count = 0;
          }
        });
        data[data.length - count].rowspan = count;
      }
      return data;
    }
  }, {
    key: "dataProductTransform",
    get: function get() {
      var data = {
        colsProducts: {},
        rowDate: {}
      };
      this.data.forEach(function (giveaway) {
        return giveaway.giveawayDetails.forEach(function (e) {
          data["colsProducts"][e.product.name] = 0;
        });
      });
      var total = (0, _objectSpread2.default)({}, data["colsProducts"]);
      this.data.forEach(function (giveaway) {
        giveaway.giveawayDetails.forEach(function (e) {
          var date = (0, _moment.default)(giveaway.createdAt * 1000).format("MM/YYYY");
          var nameProduct = e.product.name;
          if (!data["rowDate"][date]) {
            data["rowDate"][date] = (0, _objectSpread2.default)({}, data["colsProducts"]);
          }
          data["rowDate"][date][nameProduct] += e.quantity;
          total[nameProduct] += e.quantity;
        });
      });
      data["rowDate"]["Total"] = total;
      return data;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], GiveawayExcelTable.prototype, "data", void 0);
GiveawayExcelTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({})], GiveawayExcelTable);
var _default = exports.default = GiveawayExcelTable;